// extracted by mini-css-extract-plugin
export default {"headerTimestamp_dropdown":"HeaderTimestamp_headerTimestamp_dropdown__nWblP","headerTimestamp_text":"HeaderTimestamp_headerTimestamp_text__7AgOT"};